import React from 'react';
import getIdNameFromLabel from '../../../contentful/getIdNameFromLabel';
import {AccordionItemProps, ContentfulAccordionItem} from '../../../types';
import RichText from '../Text/RichText/RichText';

export function createFlatItems(items: ContentfulAccordionItem[]): AccordionItemProps[] {
  return items.map(({label, content}: ContentfulAccordionItem) => ({
    label,
    id: getIdNameFromLabel(label),
    children: <RichText content={content} />,
  }));
}
